import { MULTI_AGENT_ROLES, getMultiAgentRoleById as getCanonicalRoleById, listMultiAgentRoleIds as listCanonicalRoleIds, validateMultiAgentRoleRegistry as validateCanonicalRegistry, } from "../multiAgent/roles.js";
import { MULTI_AGENT_PRESETS, MULTI_AGENT_MAX_AGENTS, validateAgentCount, resolveAgentPreset, } from "../multiAgent/presets.js";
export const AGENT_REGISTRY = MULTI_AGENT_ROLES;
export function getAgentById(id) {
    return getCanonicalRoleById(id);
}
export function listAgentIds() {
    return [...listCanonicalRoleIds()];
}
export const MAX_AGENTS = MULTI_AGENT_MAX_AGENTS;
export const AGENT_PRESETS = MULTI_AGENT_PRESETS;
export function validateRequestedAgentCount(requested) {
    return validateAgentCount(requested);
}
export function resolveMaxAgents(requested) {
    return resolveAgentPreset(requested);
}
export function assertNoLiveAgents() {
    for (const agent of AGENT_REGISTRY) {
        if (agent.executionMode === "live") {
            throw new Error(`SAFETY VIOLATION: Agent ${agent.id} has executionMode=live in registry`);
        }
    }
}
export function validateAgentRegistry() {
    return validateCanonicalRegistry();
}
//# sourceMappingURL=registry.js.map